import { useNavigate } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import ErrorPageLayout from '@/components/ux/ErrorPageLayout';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <ErrorPageLayout
      code="404"
      title="Page not found"
      description="The page you are looking for does not exist, was moved, or you may not have access."
      icon={FileQuestion}
      onPrimary={() => navigate('/')}
    />
  );
}
